export default [
    { id: 0, name: "Cut In Half" },
    { id: 1, name: '5" AND BALANCE' },
    { id: 2, name: 'Full Length' },
    { id: 3, name: 'Custom', isCustom: true },
  ]
